import 'dayjs/plugin/utc';
export function getUTCTime(timestamp) {
    return this.$dayjs(timestamp * 1000)
        .utcOffset(3)
        .format();
}
